import { Path, Range, Text } from '../../core';
import type { Decorate } from '../../types';
import { getDictationCheckStore } from './store';

export const decorate: Decorate = ([node, path], { editor }) => {
  if (!Text.isText(node)) return [];
  const leafRange = { anchor: { path, offset: 0 }, focus: { path, offset: node.text.length } };
  return getDictationCheckStore(editor)
    .getSnapshot()
    .items.flatMap((item) => {
      const range = item.rangeRef.current;
      if ((item.status !== 'open' && item.status !== 'applied') || !range) return [];
      const intersection = Range.intersection(range, leafRange);
      if (!intersection || (!Range.isCollapsed(range) && Range.isCollapsed(intersection)))
        return [];
      return [
        {
          ...intersection,
          dictationCheck: {
            id: item.change.id,
            kind: item.status === 'applied' ? ('applied' as const) : ('suggestion' as const),
            // Only the final leaf gets the ghost, even when formatting splits the word.
            endOffset: range.focus.offset,
            replacement:
              item.status === 'open' && Path.equals(range.focus.path, path)
                ? item.change.replacement
                : undefined,
          },
        },
      ];
    });
};
